import React, {useState, useEffect} from 'react';
import StyleButton from './StyleButton';


export default function InlineToolbar({editorState, onToggle}) {

    const currentStyle = editorState.getCurrentInlineStyle();

    return <div className="toolbar">
        {INLINE_TYPES.map(([type, label]) =>
            <StyleButton
                key={type}
                type={type}
                label={label}
                onToggle={type => onToggle(type)}
                active={currentStyle.has(type)}
            />
        )}
    </div>;
};


const INLINE_TYPES = [
    ['BOLD', <b>B</b>],
    ['ITALIC', <i>i</i>],
    ['UNDERLINE', <u>U</u>],
    // ['CODE', 'Code'],
];
